import Swiper from "@modules/swiper";
import { Navigation, A11y, Keyboard, Autoplay } from "@modules/swiper/modules";

/*import '@modules/swiper/css';*/
import "@modules/swiper/modules/a11y";
import "@modules/swiper/modules/keyboard";
import "@modules/swiper/modules/navigation";
import "@modules/swiper/modules/pagination";
import $ from "@modules/jquery";
var language = document.getElementsByTagName("html")[0].getAttribute("lang");
SlideMessageNext = language === "it" ? "Mostra slide precedente" : "Nächstes Folie anzeigen";
SlideMessagePrev = language === "it" ? "Mostra immagine precedente" : "Vorheriges Folie anzeigen";
export function SliderTextImageRightBlock() {

    const SliderElementTextImageRightBlock = document.querySelector(".SliderTextImageRightBlock");
   
    if (SliderElementTextImageRightBlock) {
       
        const swiperInstance = new Swiper(SliderElementTextImageRightBlock, {
            modules: [Navigation, A11y, Keyboard, Autoplay],
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            loop: true,
            a11y: {
                prevSlideMessage: SlideMessageNext,
                nextSlideMessage: SlideMessagePrev,
            },
            centeredSlides: false,
           
            keyboard: {
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true,
            },
            grabCursor: true,
            navigation: {
                prevEl: '.arrow-left-SliderTextImageRightBlock',
                nextEl: '.arrow-right-SliderTextImageRightBlock',
            },
           
               
           
        });

         // Riferimenti ai pulsanti
    const playButton = document.querySelector('.arrow-play-SliderTextImageRightBlock');
    const stopButton = document.querySelector('.arrow-stop-SliderTextImageRightBlock');
    if (playButton) {
        playButton.style.display = 'none';
    }
    //console.log(playButton);
    //console.log(stopButton);
    const updateButtonVisibility = () => {
        if (swiperInstance.autoplay.running) {
            //console.log("running")
            playButton.style.display = 'none'; 
            stopButton.style.display = 'block';
        } else {
            playButton.style.display = 'block'; 
            stopButton.style.display = 'none'; 
        }
    };

    // Aggiungi evento per il pulsante "Play"
    if (playButton) {
        playButton.addEventListener('click', () => {
            swiperInstance.autoplay.start(); 
            updateButtonVisibility()
           
        });
    }

    // Aggiungi evento per il pulsante "Stop"
    if (stopButton) {
        stopButton.addEventListener('click', () => {
            swiperInstance.autoplay.stop(); 
            updateButtonVisibility()
           
        });
    }

    }
    
   
}